import { Dialog, DialogTitle, DialogContent, Box, LinearProgress, Typography, IconButton, TextField, DialogActions, Button } from "@material-ui/core";
import { Pause, PlayArrow, Stop } from "@material-ui/icons";
import React, { useEffect, useImperativeHandle, useState, useRef } from "react";

const LongProgressDialog = React.forwardRef((props, ref) => {
    const {open, onClose, onEntered, title, onPause} = props

    const [isPaused, setIsPaused] = useState(false);
    const [log, setLog] = useState("");
    const [progress, setProgress] = useState(0);

    const textFieldRef = useRef();

    useImperativeHandle(
        ref, () => ({
            addProgressLog(newEntry){
                setLog(prev => {
                    return `${prev}${prev !== null && prev.length > 0 ? '\n': ''}${newEntry}`
                })
            },
            updateProgress(current, max = 1){
                if(max === 0) max = 1;
                setProgress(Math.ceil((current/max) * 100))
                
            }
        })
    )

    useEffect(()=> {
        if(textFieldRef.current !== null && textFieldRef.current !== undefined){
            textFieldRef.current.scrollTop = textFieldRef.current.scrollHeight
        }
    }, [progress])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            onEntered={onEntered}
            disableBackdropClick
            maxWidth='sm'
            fullWidth
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Box display='flex' flexDirection='column'>
                    <Box display='flex' alignItems='center' style={{width: '100%'}}>
                        <Box minWidth={35}>
                            <IconButton size='small' onClick={()=>{onPause(); setIsPaused(!isPaused)}}>
                                {
                                    isPaused ?
                                    <PlayArrow />
                                    :
                                    <Pause />
                                }
                            </IconButton>
                        </Box>
                        <Box minWidth={35}>
                            <IconButton size='small' onClick={onClose}>
                                <Stop />
                            </IconButton>
                        </Box>
                        <Box width="100%" mr={1}>
                            <LinearProgress variant="determinate" value={progress}/>
                        </Box>
                        <Box minWidth={35}>
                            <Typography>
                                {progress}%
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                    <TextField
                        multiline
                        fullWidth
                        rows={10}
                        rowsMax={10}
                        variant='outlined'
                        disabled
                        value={log}
                        inputRef={textFieldRef}
                    />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button color='primary' onClick={onClose}>
                    Cancel Process
                </Button>
            </DialogActions>
        </Dialog>
    )
})

LongProgressDialog.defaultProps = {
    title: "Long Process",
    open: false,
    onClose: ()=>{},
    onEntered: ()=>{}
}

export default LongProgressDialog